export const strings = {
  developed_by_bale: "توسعه داده شده توسط بله ",
  connection_error: "خطا در اتصال به سرور",
  order: {
    sponsored: {
      info: {
        errors: {
          cant_have_link: "قرار دادن لینک در متن تبلیغ امکان پذیر نیست.",
        },
        saved_successfully: "تغییرات با موفقیت ذخیره شد.",
        edit: "ویرایش",
        long_title: "تعداد کاراکترها بیش از حد مجاز است.",
        title: "عنوان تبلیغ",
        label: "عنوان تبلیغ (اختیاری)",
        help: "این عنوان فقط به شما نمایش داده می‌شود.",
        placeholder: "عنوان تبلیغ خود را وارد کنید ",
        button_helper: "نحوهٔ نمایش لینک تبلیغ",
        button_type: "به‌صورت دکمه",
        text_type: "در متن تبلیغ",
        with_button_title: "نمایش لینک تبلیغ به‌ صورت دکمه",
        with_text: "نمایش لینک در متن تبلیغ",
        in_button_shape: "به‌صورت دکمه",
        button_title: "عنوان دکمه",
        button_title_helper: "متن دکمه نباید شامل حروف انگلیسی و اموجی باشد.",
        button_english_error: "متن دکمه نباید شامل حروف انگلیسی باشد.",
        button_title_placeholer: "برای مثال: جزئیات بیشتر",
        button_link: "لینک دکمه",
        button_link_placeholder: "https://ble.ir/info",
        button_link_helper: "لینک صفحه‌ای که با کلیک روی دکمه باز می‌شود. ",
        join: "عضویت",
        ad_text: "متن تبلیغ",
        ad_text_placeholder: "متن تبلیغ خود را وارد کنید",
      },
    },
  },
  common: {
    button: {
      submit: "تایید",
      submit_and_continue: "تایید و ادامه",
      save: "ذخیره",
      cancel: "انصراف",
      pay: "پرداخت",
      sure: "مطمئنم",
      confirm_and_submit: "تایید و ثبت اطلاعات",
      submit_info: "ثبت اطلاعات",
      understood: "متوجه شدم",
      submit_request: "ثبت درخواست",
      close: "بستن",
      buy: "خرید",
      enter: "ورود",
      more_info: "اطلاعات بیشتر",
      final_submit: "ثبت نهایی",
      restart: "شروع مجدد",
    },
    error: {
      auth_pending: "درخواست شما در حال بررسی است.",
      required: "وارد کردن این فیلد الزامی است.",
      all_required: "همهٔ قسمت‌ها تکمیل نشده ‌است.",
      image_max_size: "حداکثر حجم تصویر ۱۰ مگابایت است.",
      image_max_height: "حداکثر ارتفاع تصویر ۳۰۰ پیکسل است.",
      file_max_size: "حداکثر حجم فایل ۱۰ مگابایت است.",
      file_type: "فقط امکان انتخاب فایل با فرمت PNG, JPEG و PDF وجود دارد.",
    },
    input: {
      image: {
        label: "بارگذاری تصویر",
      },
      optional_image: {
        label: "بارگذاری تصویر(اختیاری)",
      },
      file: {
        label: "بارگذاری فایل",
      },
    },
    date: "تاریخ",
    click: "کلیک",
    view: "بازدید",
    person: "نفر",
    rial: "ریال",
    toman: "تومان",
    weekDays: {
      "0": "۱ شنبه",
      "1": "۲ شنبه",
      "2": "۳ شنبه",
      "3": "۴ شنبه",
      "4": "۵ شنبه",
      "5": "جمعه",
      "6": "شنبه",
    },
    price: "مبلغ قابل پرداخت",
  },
  ad_excel: {
    id: "شناسه",
    title: "عنوان",
    description: "توضیحات",
    link: "لینک",
    link_title: "عنوان لینک",
    owner_id: "شناسه‌ی صاحب",
    view_count: "تعداد بازدید",
    click_count: "تعداد کلیک",
    created_at: "تاریخ ساخت",
    desired_start_time: "تاریخ شروع دلخواه",
    start_time: "تاریخ شروع",
    finish_time: "تاریخ پایان",
    state: "وضعیت",
    spot: "موقعیت",
    platform: "پلتفرم",
    topic: "موضوع",
    ctr: "نرخ کلیک",
    rejection_reason: "دلیل رد شدن",
    tag_1: "تگ ۱",
    tag_2: "تگ ۲",
  },
  ad_sale: {
    title: "سامانه سفارش تبلیغ",
    add: "ثبت سفارش تبلیغ",
    create_campaign: "ساخت کمپین",
    enter: "ورود به پنل",
    first_order_message: "اولین سفارش تبلیغت رو ثبت کن.",
    increase_your_credit: "لطفا ابتدا اعتبارتان را افزایش دهید.",
    small_channels_aid: "حمایت از کانال های کوچک",
    credit_has_expired: "لطفا ابتدا یک بسته جدید خریداری کنید.",
    welcome: "خوش آمدی!",
    download_campaigns_report: "دانلود گزارش کمپین‌ها",
    download_ads_report: "دانلود گزارش ‌تبلیغ‌ها",
    ordered_ads_list: {
      title: "لیست سفارش ها",
      adImage: "تصویر تبلیغ",
      adSpot: "جایگاه تبلیغ",
      adStatus: "وضعیت تبلیغ",
      clickOrView: "کلیک/بازدید",
      more: "بیشتر",
      startCampaign: "شروع کمپین",
      status: "وضعیت:",
      stop: "توقف:",
      show_date: "تاریخ نمایش:",
      ad_type: {
        channel: "سنجاق شده کانال",
        dialog: "تب گفتگو",
        sponsored_message: "پست کانال",
      },
    },
  },
  side_bar: {
    help_guide: "راهنمایی و آموزش",
    order: "سفارش تبلیغ",
    calendar: "تقویم تبلیغات",
    ad_prices: "قیمت تبلیغات",
    profile: "پروفایل",
    notification: "اعلان‌ها",
    tutorial: "آموزش تبلیغات",
    faq: "سؤالات متداول",
    support: "درخواست پشتیبانی",
    terms: "قوانین و مقررات",
    council: "مشاوره اختصاصی تبلیغات",
    logout: "خروج از حساب کاربری",
    new: "جدید",
    package: {
      title: "ارتقای حساب کاربری 👑",
      description:
        "با ارتقای حساب می‌توانید تبلیغ‌هایی بدون تاریخ انقضا بسازید.",
      more_info: "اطلاعات بیشتر",
    },
    yalda_package: {
      title: "بستۀ اختصاصی «شب یلدا» 🍉",
      title_no_icon: "بستۀ اختصاصی «شب یلدا»",
      description: "۱۰ درصد تخفیف + فرصت حضور در جایگاه جدید تبلیغات",
    },
    custom_pack_notif: {
      new_notif: "اعلان جدید",
      your_custom_pack: "بستۀ اختصاصی شما 📦",
      pack_created_by_admin: "بستۀ شما توسط ادمین تبلیغات «بله» ایجاد شد.",
      other_packs: "مشاهدۀ بسته‌های دیگر",
    },
  },
  choose_ad_type: {
    confirm: "تایید و ادامه",
    dialog_ad_tab: {
      title: "تبلیغ تب گفتگو",
      desc: "تبلیغ شما مانند آنچه در تصویر زیر می‌بینید، در بالای صفحهٔ لیست گفتگوها در «بله» سنجاق‌ می‌شود.",
    },
    pinned_ad_tab: {
      title: "تبلیغ سنجاق شده کانال",
      desc: "تبلیغ شما مانند آنچه در تصویر زیر می‌بینید، در بالای صفحهٔ کانال‌های «بله» سنجاق‌ می‌شود.",
      disabled: "این جایگاه در حال حاضر فعال نیست.",
    },
  },
  order_ad: {
    submitted_successfully: "ثبت سفارش با موفقیت انجام شد.",
    title: {
      dialog: "ثبت اطلاعات تبلیغ تب گفتگو",
      channel: "ثبت اطلاعات تبلیغ سنجاق شده کانال",
      campaign: "ثبت اطلاعات کمپین تب گفتگو",
      choose_ad_type: "انتخاب نوع تبلیغ",
      submit: "ثبت نهایی",
      invoice: "صدور فاکتور",
      additional_info: "اطلاعات تکمیلی",
      contact_info: "ثبت درخواست",
      sponsored_info: "ثبت اطلاعات تبلیغ پست کانال",
      sponsored_final_step: "ثبت نهایی",
      sponsored_details_step: "ثبت اطلاعات",
    },
    sponsored_steps: {
      info: "اطلاعات تبلیغ",
      image: "بارگذاری تصویر",
      details: "جزئیات نمایش",
      final: "تایید نهایی",
    },
    phases: {
      submit_ad: "سفارش تبلیغ",
      submit_ad_info: "ثبت اطلاعات تبلیغ",
      submit_ad_settings: "تنظیمات تبلیغ",
      submit_ad_target: "هدفمندی تبلیغ",
      submit_ad_preview: "پیش‌نمایش تبلیغ",
      first_step: "مرحلۀ اول",
      second_step: "مرحلۀ دوم",
      third_step: "مرحلۀ سوم",
      forth_step: "مرحلۀ چهارم",
      fifth_step: "مرحلۀ پنجم",
    },
  },
  dialog_ad_form: {
    select_ad_type: {
      preview: "پیش‌نمایش جایگاه",
      dialog_description:
        "تبلیغ شما در بالای زبانۀ گفتگوی «بله» در هر دو نسخۀ وب و اندروید نمایش داده می‌شود.",
      sponsoredMessage_description:
        "متن تبلیغ شما به صورت آخرین پیام متنی در کانال‌های «بله» در هر دو نسخۀ اندروید و وب نمایش داده می‌شود.",
      mybank_description:
        "نام و لوگوی کسب‌و‌کار شما در بخش «خدمات پیشنهادی» زبانۀ بانک من «بله»، در هر دو نسخۀ وب و اندروید نمایش داده می‌شود.",
      onboarding_description:
        "این جایگاه در صفحۀ آنبوردینگ «بله» در نسخۀ اندروید و به کاربران جدید نمایش داده می‌شود.",
      placement_type: "نوع جایگاه",
      select_placement:
        "یکی از جایگاه‌ها را برای مشاهدۀ پیش‌نمایش انتخاب کنید.",
      order_ad_info: "برای ثبت درخواست تبلیغ اطلاعات زیر را وارد کنید.",
      minimum_members: "تعداد اعضای کانال باید حداقل {count} عدد باشد",
      business_name: "نام کسب‌وکار",
      business_name_placeHolder: "مثلا فناوران اطلاعات...",
      channel_id: "شناسۀ کانال",
      channel_id_placeHolder: "http://ble.ir/",
      mobile_num: "شماره همراه",
      mobile_num_placeHolder: "۰۰۰۹۱۲۳۴۵۶۷۸۹",
      modal_success_header: "درخواست شما با موفقیت ثبت شد. ",
      modal_success_desc:
        "درخواست شما در اسرع وقت بررسی می‌شود. منتظر تماس همکاران ما باشید.",
      spot_texts: {
        dialog: "تب گفتگو",
        shop: "فروشگاه",
        onboarding: "آنبوردینگ",
        mybank: "بانک من",
        sponsored_message: "پُست کانال",
      },
    },
    info_step: {
      submit: "ادامه",
      title_label: "عنوان تبلیغ",
      title_help_placeholder: "عنوان تبلیغ را وارد کنید",
      text_label: "متن تبلیغ",
      text_placeholder: "متن تبلیغ را وارد کنید",
      image_size_limit_info: "فرمت JPEG/PNG و حداکثر حجم ۱۰ مگابایت",
      link_label: "لینک تبلیغ",
      link_placeholder: "لینک رونوشت شده را جای‌گذاری کنید",
      link_help:
        "لینک پست، کانال و یا سایتی را که می‌خواهید تبلیغ شود، وارد کنید",
      // "لینک پستی که می‌خواهید تبلیغ شود را وارد کنید.\nمثال لینک داخل بله: https://ble.ir/mohtavadaran\nمثال لینک خارج بله: https://my.bmi.ir\n",
      invalid_link_error: "لینک وارد شده معتبر نمی‌باشد.",
      join_link_error: "لینک وارد شده، لینک پیوستن به کانال است.",
      image_size_exceeded_error: "حداکثر حجم تصویر ۱۰ مگابایت است.",
      force_join: "لینک «عضویت اجباری»",
      price_per_click: "قیمت هر کلیک",
      force_join_modal_text:
        "با وارد کردن لینک «عضویت اجباری»، قیمت هر کلیک به {newPrice} تومان افزایش می‌یابد. آیا از انجام این کار مطمئن هستید؟",
      errors: {
        only_english: "قرار دادن عنوانی که حروف فارسی ندارد، امکان‌پذیر نیست",
        forbiddenPlatforms:
          "وارد کردن لینک سایر شبکه‌های اجتماعی امکان‌پذیر نیست",
        low_members:
          "تبلیغ در زبانۀ گفتگو برای کانال‌های زیر ۲۰۰ نفر امکان‌پذیر نیست",
        no_channel_found: "کانالی با این لینک در «بله» وجود ندارد",
      },
    },
    publish_step: {
      // max_stop_value_error: " حداکثر مقدار توقف می‌تواند { count } باشد",
      max_stop_error:
        "براساس اعتبار شما، تعداد {type} نمیتواند بیشتر از {count} {type} باشد.",
      min_stop_value_error: "حداقل مقدار توقف می‌تواند { count } باشد",
      step_title: "تکمیل اطلاعات تبلیغ",
      submit: "ادامه",
      ad_type_title: "سفارش تبلیغ به‌ازای:",
      type_differences: "تفاوت تبلیغ بازدیدی و کلیکی",
      type_notes: [
        "در سفارش تبلیغات به‌ازای تعداد بازدید، هزینهٔ تبلیغ شما بر اساس هر بار مشاهدهٔ تبلیغ در تب گفتگو محاسبه می‌شود.",
        "در سفارش تبلیغات به‌ازای کلیک، هزینهٔ تبلیغ شما بر اساس هر بار کلیک روی تبلیغ در تب گفتگو محاسبه می‌شود.",
      ],
      view_count: "تعداد بازدید",
      view_count_stop_value: "تعداد بازدید (اختیاری)",
      click_count_stop_value: "تعداد کلیک (اختیاری)",
      view_count_placeholder: "تعداد بازدید خود را وارد کنید ",
      click_count: "تعداد کلیک",
      click_count_placeholder: "تعداد کلیک خود را وارد کنید ",
      //       view_count_info: `حداقل تعداد بازدید: {count} بازدید
      // قیمت هر بازدید: {price}`,

      view_count_info: `حداقل تعداد بازدید: {count} بازدید`,
      //       click_count_info: `حداقل تعداد کلیک: {count} کلیک
      // قیمت هر کلیک: {price} ریال `,
      click_count_info: `حداقل تعداد کلیک: {count} کلیک`,
      supportive_discount: "(با {percentage}٪ تخفیف حمایتی: {price} ریال)",
      min_view_count_error: "تعداد بازدید باید بیشتر از {count} تا باشد",
      max_view_count_error: `حداکثر تعداد بازدید باید {count} باشد.`,
      min_click_count_error: "تعداد کلیک باید بیشتر از {count} تا باشد",
      max_click_count_error: `حداکثر تعداد کلیک باید {count} باشد.`,
      min_join_click_count_error:
        "تعداد کلیک برای لینک «عضویت اجباری» باید بیشتر از {count} تا باشد.",
      max_join_click_count_error:
        "حداکثر تعداد کلیک برای لینک «عضویت اجباری» باید {count} باشد.",
      advertising_start_date: "تاریخ شروع تبلیغ",
      batch_advertising_start_date: "زمان نمایش تبلیغ",
      choose_date: "انتخاب تاریخ",
      show_calender: "مشاهدۀ تقویم",
      requires_approve:
        "زمان شروع تبلیغ را بعد از تایید توسط ادمین می‌توانید انتخاب کنید.",
      date_not_selectable: "این تاریخ قابل انتخاب نیست.",
      terms_and_conditions_link_text: "قوانین و مقررات سرویس سفارش تبلیغ",
      i_have_studied_and_agreed: "را مطالعه کردم و با آن‌ها موافقم.",
      all: "تمام",
      choose_ad_start_date: "انتخاب تاریخ شروع تبلیغ",
      instant_ad: "تبلیغ فوری",
      instant_ad_display: "نمایش فوری تبلیغ",
      instant_ad_help:
        "با پرداخت {percentage}٪ مبلغ بیشتر، تبلیغ شما دقایقی پس از پرداخت و بدون نیاز به انتظار در صف، نمایش خود را آغاز خواهد کرد.",
      instant_ad_toast:
        "با انتخاب گزینه «تبلیغ فوری»، {percentage}٪ به مبلغ نهایی اضافه شد.",
      min_valid_date_error: `تاریخ شروع تبلیغ باید {date} روز بعد از ثبت سفارش باشد.`,
      divisible_error_view: "تعداد بازدید، باید مضرب {value} باشد.",
      divisible_error_click: "تعداد کلیک، باید مضرب {value} باشد.",
      max_valid_date_error: `تاریخ شروع تبلیغ باید حداکثر تا {date} روز آینده باشد.`,
      batch_warning:
        "به دلیل حجم سفارش، نمایش این تبلیغ بیش از ١ روز طول می‌کشد.  ",
      only_for_view: " این تقویم صرفاً برای مشاهده است.",
      calender_description:
        "برای اطلاع از زمان‌های آزاد جهت ثبت تبلیغ، تقویم تبلیغات را مشاهده کنید.",
      errors: {
        forceJoinProvided: "شما لینک «عضویت اجباری» وارد کرده‌اید.",
      },
      more_settings: "سایر تنظیمات",
    },
    more_settings_step: {
      title: "هدفمندی تبلیغ  ",
      help_modal_text: `
      هدفمندی تبلیغ به‌معنای نمایش تبلیغ به افرادی است که احتمال بیشتری دارد به تبلیغ شما علاقه‌مند باشند.
      با هدفمندسازی تبلیغ خود، می‌توانید بازدهی تبلیغ را افزایش دهید.`,
      tags: {
        title: "دسته‌بندی تبلیغ",
        description:
          "انتخاب دسته‌بندی کمک می‌کند که تبلیغ شما به‌طور هدفمند، به کاربران علاقه‌مند به موضوع تبلیغتان نمایش داده شود.",
        main: "دسته‌بندی تبلیغ",
        sub: "دسته‌بندی فرعی",
        select: "تعیین دسته‌بندی",
      },
      gender_target: {
        rawTitle: "جنسیت کاربران",
        title: "جنسیت کاربران (اختیاری)",
        example: "برای مثال: فقط آقایان",
        description:
          "با انتخاب جنسیت، قیمت {percentage}٪ افزایش خواهد یافت.توجه داشته باشید که احتمال خطا در تشخیص جنسیت برخی کاربران وجود دارد.",
        genders: {
          none: "هیچ‌کدام",
          male: "فقط آقایان",
          female: "فقط خانم ها",
        },
        toast:
          "با انتخاب گزینه «جنسیت کاربران»،{percentage}٪ به مبلغ نهایی اضافه شد.",
      },
    },
  },
  sponsored_messages: {
    finalStep: {
      info: "اطلاعات سفارش",
      view_count: "تعداد بازدید:",
      each_view: "بازدید هر نفر: {price} ریال",
      finalPrice: "مبلغ نهایی",
    },
    calculating: "در حال محاسبه قیمت نهایی",
    imageStep: {
      imageInput: "تصویر تبلیغ (اختیاری)",
      preview: "پیش نمایش تبلیغ",
      previewHelper:
        "تبلیغ شما به این صورت در انتهای کانال‌ها نمایش داده می‌شود.",
    },
    view_details: "مشاهدهٔ جزئیات",
    only_english: "قرار دادن پیامی که حروف فارسی ندارد، امکان‌پذیر نیست",
    message_placeholder: `پوشاک کودک و نوجوان ما یکی از...                             آموزش زبان به روش...`,
    message_helper: "وارد کردن لینک تبلیغ الزامی است.",
    submit_steps: {
      MainInfo: "اطلاعات تبلیغ",
      ViewOptions: "تنظیمات سفارش",
      Moreinfo: "اطلاعات سفارش",
    },
    more_info: "اطلاعات بیشتر",
    low_members: "تبلیغ پست کانال برای کانال‌های زیر ۲۰۰ نفر امکان‌پذیر نیست",
    price_isnt_fixed:
      "قیمت بازدید در این جایگاه ثابت نیست و بر اساس جزییات سفارش شما تغییر می‌کند.",
    image_size_format_info: "فرمت JPEG/PNG و حداکثر حجم ۱۰ مگابایت",
    memberSegments: {
      less_than_max: "کمتر از {max} هزار عضو",
      between_min_max: "بین {min} هزار تا {max} هزار عضو",
      more_than_min: "بیش از {min} هزار عضو",
    },
    membersCount: "تعداد عضو",
    channelMembersTitle: "تعداد عضو کانال‌های هدف",
    tagsTitle: "دسته‌بندی موضوعی تبلیغ",
    priceTitle: "دربارۀ قیمت‌گذاری این جایگاه",
    errors: {
      join_link:
        "در صورت افزودن لینک «عضویت اجباری»، عنوان دکمه، «عضویت» می‌شود.",
      max_char_reached: "متن تبلیغ باید کمتر از {maxChar} کاراکتر داشته باشد.",
      sponsored_text_required: "وارد کردن متن تبلیغ الزامی است.",
      sponsored_message_image_ratio:
        "تصاویر در ابعاد ۳:۲ نمایش داده خواهند شد.",

      too_many_links: "تعداد لینک‌ها نباید بیشتر از یک عدد باشد.",

      no_link: "وارد کردن لینک الزامی است",
      force_join_not_allowed: "قرار دادن لینک «عضویت اجباری» امکان‌پذیر نیست.",
      forbiddenPlatforms:
        "وارد کردن لینک سایر شبکه‌های اجتماعی امکان‌پذیر نیست",
    },
    view_count_placeholder: "تعداد بازدید خود را وارد کنید",
    channelMembersModalText:
      "با انتخاب تعداد عضو کانال‌های هدف، تبلیغ شما به صورت هدفمندتر و فقط به اعضای این کانال‌ها نمایش داده می‌شود.",
    tagsModalText:
      "با انتخاب دسته‌بندی موضوعی کانال‌های هدف، تبلیغ شما به صورت هدفمندتر و فقط به اعضای این کانال‌ها نمایش داده می‌شود.",
    min_sponsored_view_order: "تعداد بازدید باید بیشتر از {min} باشد.",
    max_sponsored_view_order: `حداکثر تعداد بازدید باید {max} تا باشد.`,
    view_count: "تعداد بازدید ",
    preview: {
      order_info: "اطلاعات سفارش",
      order_preview: "پیش‌نمایش تبلیغ",
      ad_description: "متن تبلیغ:",
      ad_link: "لینک تبلیغ:",
      view_count: "تعداد بازدید:",
      view_options: "تنظیمات نمایش",
      members_count: "تعداد عضو:",
      category: "دسته‌بندی:",
      preview_modal_helper:
        "تبلیغ شما به این صورت در انتهای کانال‌ها نمایش داده می‌شود.",
      ad: "تبلیغ",
    },
  },
  upload_photo: "بارگذاری تصویر",
  second: "ثانیه",
  login: {
    header: "ورود از طریق «بله»",
    description: "سامانه‌ای برای ثبت سفارش تبلیغ در «بله»",
    bale_phone: [
      "شماره همراهی که با آن در «بله» ثبت‌نام کرده‌اید را وارد کنید. کد ورود از طریق «بله» و در ",
      "بازوی دستیار تبلیغات ",
      "برای شما ارسال می‌شود.",
    ],
    login_problem: ["مشکلی در ورود دارید؟", " راهنمایی"],
    remaining_time: ["انقضای کد تا ", "{time} ثانیه ", "دیگر"],
    otp_expired: ["کد ورود منقضی شد. ", "ارسال مجدد کد"],
    bale_otp: [
      "کد ورود در ",
      "بازوی دستیار تبلیغات ",
      "برای شما ارسال شد.",
      " کد را در این بخش وارد کنید.",
    ],
    sms_otp: "کد ورودی که از طریق پیامک دریافت کرده‌اید را وارد کنید.",
    no_bale_account_modal: {
      title: "ورود به بله",
      content:
        "برای ورود به پنل تبلیغات باید در «بله» حساب کاربری داشته باشید. برای ساخت حساب و ورود به پنل کافیست یکبار فرایند ثبت‌ نام را طی کنید.",
      primary: "ورود به «بله»",
    },
    login_guide_modal: {
      title: "راهنمایی دربارۀ ورود به پنل",
      steps: [
        "۱. ابتدا وارد یکی از نسخه‌های اندروید یا {web} شوید.",
        "۲. به بخش گفتگو و سپس به بخش «بازو» بروید.",
        "۳. کد ورود ازطریق دستیار تبلیغات برای شما ارسال شده است.",
      ],
      bale_web: "وب «بله»",
    },
    phone: {
      label: "شماره همراه:",
      placeholder: "۹۱۲۳۴۵۶۷۸۹",
      prefix: "+۹۸",
      error: "شماره همراه اشتباه وارد شده است.",
    },
    otp: {
      label: "کد ورود",
      placeholder: "XXXXX",
      error: "کد وارد شده اشتباه است.",
    },
  },
  register: {
    title: "ثبت نام",
    name: {
      label: "نام و نام‌خانوادگی",
      placeholder: "نام و نام‌خانوادگی خود را وارد کنید",
    },
    description:
      "در صورتی که نمایندهٔ سازمان‌ها یا شرکت‌ها هستید کاربر حقوقی را انتخاب کنید. در غیر این صورت کاربر حقیقی را انتخاب کنید.",
    userType: {
      title: "نوع کاربری:",
      natural: "کاربر حقیقی",
      legal: "کاربر حقوقی",
    },
    business: {
      label: "نام کسب‌وکار",
      placeholder: "نام کسب‌و‌کار خود را وارد کنید",
    },
    signup_modal: {
      title: "ساخت حساب کاربری در «بله» با موفقیت انجام شد.",
      content:
        "برای مشاهدۀ اعلانات سفارش تبلیغ خود می‌توانید به بازوی «دستیار تبلیغات بله» بروید.",
      go_to_panel: "رفتن به پنل",
    },
  },
  logout: {
    description: "آیا از خروج از حساب کاربری خود اطمینان دارید؟",
    title: "خروج",
  },
  profile: {
    title: "پروفایل",
    national_code: {
      label: "کد ملی",
      legal_label: "شناسه ملی",
      placeholder: "XXXXXXXXXX",
      error: {
        not_matched: "کد ملی وارد شده با شماره همراه شما مطابقت ندارد.",
        invalid: "کد ملی وارد شده نامعتبر است.",
      },
    },
    address: {
      label: "آدرس",
      placeholder: "استان، شهر و آدرس کامل را وارد نمایید",
    },
    economic_code: {
      label: "شماره اقتصادی",
      placeholder: "XXXXXXXXXX",
    },
    phone: {
      label: "شماره تلفن ثابت",
      placeholder: "XXXXXXXXXX",
    },
    postcode: {
      label: "کد پستی",
      placeholder: "XXXXXXXXXX",
      error: "کد پستی باید ۱۰ رقمی باشد.",
    },
    organization: {
      label: "نام کامل شرکت/سازمان",
      placeholder: "نام کامل شرکت/سازمان را وارد کنید.",
    },
    image_inputs: {
      establishment_certificate: "گواهی تاسیس",
      changes_notice: "آگهی تغییرات",
      activity_permission: "مجوز فعالیت",
    },
  },
  ad_states_labels: {
    Unknown: "نامشخص",
    AwaitingContentApproval: "در حال بررسی...",
    AwaitingPayment: "در انتظار پرداخت",
    AwaitingToShow: "در انتظار نمایش",
    Active: "در حال نمایش",
    Finished: "به پایان رسیده",
    Rejected: "رد شده",
    Canceled: "متوقف شده",
  },
  campaign_labels: {
    AwaitingApproval: "در انتظار تایید",
    Active: "درحال نمایش",
    Finished: "به پایان رسیده",
    Rejected: "رد شده",
    Canceled: "کنسل شده",
    Paused: "غیر فعال",
    Approved: "تایید شده",
  },
  upload_error: "آپلود عکس با مشکل مواجه شد.",
  adChart: {
    memebersDifferent: "تغییر اعضا در بازۀ تبلیغ:",
    joinedMembers: "تعداد جذب عضو",
    leftedMembers: "تعداد ریزش عضو",
    adReport: "گزارش تبلیغ",
    membersCount: "{count}+ عضو",
    membersDiff: "تغییر اعضا در بازۀ تبلیغ:",
  },
  order_details: {
    rejection_message: "سفارش تبلیغ شما به دلیل «{reason}» رد شده است.",
    title: "عنوان تبلیغ:",
    description: "متن تبلیغ:",
    adId: "شناسۀ تبلیغ:",
    ad_id: "شناسۀ تبلیغ",
    ad_report: "گزارش تبلیغ",
    start_date: "تاریخ نمایش تبلیغ:",
    show_date: "زمان شروع تبلیغ:",
    choose_time: "انتخاب زمان",
    view_count: "تعداد بازدید:",
    click_count: "تعداد کلیک:",
    ctr: "نرخ کلیک:",
    ad_link: "لینک تبلیغ:",
    page_title: "جزییات سفارش",
    final_price: "مبلغ نهایی",
    orderIdCopied: "شناسۀ {value} کپی شد.",
    message: "انقضای درخواست: ۴۸ ساعت پس از تایید ادمین.",
    select_date_tooltip: "زمان شروع تبلیغ‌تان را انتخاب کنید",
    chart_views_header: "تعداد کل بازدیدها: ",
    chart_clicks_header: "تعداد کل کلیک ها: ",
    views: "بازدیدها",
    clicks: "کلیک ها",
    replacing_bonus_code: "لغو حمایت و اعمال کد هدیه",
    warning_text:
      "«بله» برای حمایت از کانال‌ها، تعرفۀ تبلیغات را کاهش داده‌ است. با اعمال کد هدیه، تعرفۀ تبلیغات به حالت عادی باز می‌گردد. آیا از انجام این کار مطمئن هستید؟",
    view_price: "قیمت بازدید:",
    click_price: "قیمت کلیک:",
    not_approved_yet: "سفارش شما در انتظار تایید توسط ادمین است.",
    member_count_option: "تعداد اعضای کانال های هدف:",
    price_reduction_reason_button: "برای مشاهدۀ دلیل کاهش قیمت، کلیک کنید.",
    price_reduction_modal: {
      title: "دلیل کاهش قیمت تبلیغات",
      desc: "«بله» برای حمایت از کسب‌و‌کارها، قیمت تبلیغات را برای شما کاهش داده‌ است.",
    },
  },
  stop_campaign: {
    title: "توقف کمپین",
    header: "تنظیم توقف کمپین",
    helper_campaign:
      "شما میتوانید تعیین کنید کمپین‌تان با رسیدن به چه تعداد {type} متوقف شود.",
    settings: "تنظیم توقف کمپین",
    description_click:
      "برای مدیریت هزینه‌ها‌ می‌توانید در ورودی زیر مشخص کنید کمپین شما با رسیدن به چه تعداد کلیک متوقف شود.",
    description_view:
      "برای مدیریت هزینه‌ها‌ می‌توانید در ورودی زیر مشخص کنید کمپین شما با رسیدن به چه تعداد بازدید متوقف شود.",
  },
  campaign_details: {
    rejection_message: "سفارش کمپین شما به دلیل «{reason}» رد شده است.",
    title: "عنوان کمپین:",
    description: "متن کمپین:",
    ad_id: "شناسۀ کمپین",
    ad_report: "گزارش کمپین",
    view_count: "بازدیدها تا این لحظه:",
    click_count: "کلیک‌ها تا این لحظه:",
    ctr: "نرخ کلیک:",
    cost: "هزینه تا این لحظه:",
    ad_link: "لینک کمپین:",
    campaign_type: "نوع کمپین:",
    without_title: "بدون عنوان",
  },
  ad_time_select: {
    time_select_header: "انتخاب روز شروع تبلیغ",
    select_day: "انتخاب روز",
    select_hour: "انتخاب ساعت",
    hour: "ساعت ",
    start_day: "روز شروع",
    show_period: "بازه نمایش",
    start_hour: "ساعت شروع",
    start_time_not_selected: "ساعت شروع تبلیغ انتخاب نشده است.",
    ad_time_not_selected: "زمان شروع تبلیغ انتخاب نشده است",
    select_time_first: "ابتدا زمان شروع تبلیغ را انتخاب کنید",
    no_capacity: "ظرفیت تکمیل شده است",
    capacity_is_being_filled: "...در حال تکمیل ظرفیت",
    choose_ad_date: "تاریخ و ساعت شروع تبلیغ را انتخاب کنید.",
    reserve_on_select_date: "زمان انتخاب شده فقط بعد از پرداخت رزرو می‌شود.",
    hour_not_selectable: "ظرفیت نمایش در این ساعت به اتمام رسیده است.",
    day_not_selectable: "ظرفیت نمایش در این روز به اتمام رسیده است.",
    large_order_takes_time:
      "به دلیل بالا بودن حجم سفارش، تبلیغ شما بیش از یک روز طول می‌کشد.",
    large_order_takes_time_choose:
      "به دلیل بالا بودن حجم سفارش، نمایش تبلیغ شما بیش از یک روز طول می‌کشد. روز شروع نمایش را انتخاب کنید.",
    notified_of_next_show:
      "ساعت نمایش‌های بعدی از طریق بازوی «دستیار تبلیغات» به شما اطلاع داده می‌شود.",
  },
  invoicing: {
    invoicing: "صدور فاکتور",
    help_main: "اطلاعات زیر را برای صدور فاکتور وارد کنید.",
    help_personal: "لازم است یکبار اطلاعات زیر را برای صدور فاکتور وارد کنید.",
    help_organization:
      "چون پنل شما از نوع حقوقی است، لازم است قبل از ثبت تبلیغ، ابتدا «یکبار» اطلاعات زیر را برای صدور فاکتور وارد کنید.",
    mobile_phone: "شماره همراه:",
    national_code: "کد ملی",
    address: "آدرس",
    phone_number: "شماره تلفن ثابت",
    address_help: "استان، شهر، خیابان، کوچه، پلاک، واحد",
    postal_code: "کد پستی",
    organization_name: "نام شرکت",
    national_id: "شناسۀ ملی",
    commercial_number: "شمارۀ اقتصادی",
    establishment_notice: "آگهی تاسیس",
    notice_of_changes: "آگهی تغییرات",
    activity_notice: "مجوز فعالیت",
    enter_registered_name: "نام ثبت شدۀ شرکت را وارد کنید",
    registered_sucessfully:
      "مدارک شما در اسرع وقت توسط ادمین تبلیغات بررسی می‌شود. پس از تایید مدارک می‌توانید سفارش خود را ثبت کنید",
    request_details: "جزئیات درخواست",
    edit_request: "ویرایش درخواست",
    docs_submission_request: "درخواست ثبت مدارک",
    rejection_reason: "درخواست شما به دلایل زیر رد شده است:",
    submitted_successfully: "اطلاعات شما با موفقیت ثبت شد.",
    org_steps: {
      basic_info: "اطلاعات اولیه",
      registration_info: "اطلاعات ثبتی",
      docs: "مدارک",
    },
    errors: {
      national_phone_should_match: "کد ملی باید متعلق به صاحب شماره همراه باشد",
      national_phone_not_match:
        "کد ملی وارد شده با شماره همراه شما مطابقت ندارد.",
      postal_code_length: "کد پستی باید ۱۰ رقمی باشد.",
      national_id_length: "شناسهٔ ملی باید ۱۱ رقمی باشد.",
      commercial_number_length: "شناسهٔ اقتصادی باید ۱۱ رقمی باشد.",
      national_code_length: "کدملی باید ۱۰ رقمی باشد.",
    },
  },
  preview: {
    preview: "پیش‌نمایش",
    join: "عضویت",
    each_person: " هر نفر:",
    error_getting_price: "خطا در دریافت قیمت",
  },
  final_submit: "ثبت نهایی",
  nps: {
    title: "ثبت بازخورد",
    description:
      "چقدر احتمال دارد استفاده از خدمت تبلیغات «بله» را به دیگران توصیه کنید؟",
    suggestion_placeholder: "نوشتن توضیحات اختیاری است.",
    submit_feedback: "ثبت بازخورد",
    pros_question: "نقاط قوت خدمت تبلیغات چه بود؟ (حداکثر دو مورد)",
    cons_question: "نقاط ضعف خدمت تبلیغات چه بود؟ (حداکثر دو مورد)",
    other_pros: "سایر نقاط قوت",
    other_cons: "سایر نقاط ضعف",
    completion_message:
      "بازخورد شما با موفقیت ثبت شد؛ از اینکه وقت گذاشتید از شما سپاس‌گزاریم. 🌻",
    score_senses: {
      never_recommend: "«اصلا توصیه نمی‌کنم»",
      not_recommend: "«توصیه نمی‌کنم»",
      not_sure: "«مطمئن نیستم»",
      recommend: "«توصیه می‌کنم»",
      definitely_recommend: "«حتما توصیه می‌کنم»",
    },
    default_pros: {
      ux: "تجربه کاربری خوب",
      support: "پشتیبانی قوی",
      efficiency: "بازدهی بالا",
      price: "قیمت مناسب",
      reports: "گزارش‌دهی خوب",
      others: "سایر موارد",
    },
    default_cons: {
      ux: "تجربه کاربری بد",
      support: "پشتیبانی ضعیف",
      efficiency: "بازدهی پایین",
      price: "قیمت بالا",
      time: "عدم اجرای به‌موقع",
      others: "سایر موارد",
    },
  },
  bonus_code_errors: {
    expired: "مهلت استفاده از این کد تمام شده است.",
    used: "این کد تخفیف قبلا استفاده شده است.",
    alreadyInquired: "این کد تخفیف قبلا اعمال شده است.",
    order_date_not_in_period: "این کد در تاریخ انتخاب شده قابل استفاده نیست.",
    wrong_type: "این کد مختص تبلیغات {type} است.",
    price_threshold_not_met: "این کد مختص سفارشات بالای {threshold} تومان است.",
    code_not_provided: "کد هدیه وارد نشده است.",
    clicky: "کلیکی",
    viewy: "بازدیدی",
    sponsored_wrong_ad_placement:
      "کد تخفیف مخصوص استفاده در جایگاه تب گفتگو است.",
    full_capacity: "ظرفیت استفاده از تخفیف به پایان رسیده ‌است.",
    used_before: "قبلا از این کد تخفیف استفاده کرده‌اید.",
  },
  bonus_code_input: {
    title: "کد هدیه/تخفیف",
    hint: "کد را کپی کنید و در ورودی زیر وارد کنید.",
    placeholder: "کد را وارد کنید.",
    submit_code: "اعمال کد",
    good_bonus_code: "کد هدیه با موفقیت اعمال شد.",
    adding_bonus_code: "افزودن کد هدیه",
  },
  tabs: {
    campaign_list: "لیست کمپین‌ها",
    ads_list: "لیست تبلیغ‌ها",
  },
  campaign_state_modal: {
    no_more_actives: "امکان فعال‌سازی همزمان بیش از {value} کمپین وجود ندارد",
    no_credit: "اعتبار شما برای فعال‌سازی کمپین کافی نیست.",
    activate: {
      title: "فعالسازی کمپین",
      content: "آیا از فعالسازی کمپین خود مطمئن هستید؟",
    },
    pause: {
      title: "توقف کمپین",
      content: "آیا از توقف کمپین خود مطمئن هستید؟",
    },
  },
  credit_not_active_modal: {
    activating_campaign: "فعالسازی کمپین",
    warning_text:
      "اعتبار شما هنوز فعال نشده است. برای فعالسازی کمپین‌ها تا تاریخ تعیین‌شده در بخش «اعتبار شما» در پنل خود منتظر بمانید.",
  },
  campaign: "کمپین",
  ad: "تبلیغ",
  clicky: "کلیکی",
  viewy: "بازدیدی",
  credit: {
    title: "اعتبار",
    remaining_days: "روز مانده",
    remaining_hours: "ساعت مانده",
    your_credit: "اعتبار شما",
    remaining: "باقیمانده",
    activation_date: "تاریخ فعالسازی: {date}",
    credit_expired: "اعتبار شما به پایان رسیده است.",
  },
  packages: {
    yalda: {
      title: "ارتقای حساب کاربری 👑",
      description1: "تاریخ فعالسازی این بسته،",
      description2: " 5 روز بعد از خرید",
      description3: "خواهد بود.",
    },
    sidebar: {
      your_package: "بسته شما",
      need_credit: "اعتبار مجدد نیاز دارید؟",
      view: "مشاهده",
      buy_credit: "خرید اعتبار",
    },
    modal: {
      title: "ارتقای حساب کاربری 👑",
      description1:
        "بسته مناسب‌ خود را انتخاب و شروع کنید. تاریخ فعال‌سازی تمام بسته‌ها،",
      description2: " {days} روز بعد از خرید",
      description3: " خواهد بود.",
      buy_new_pack_desc:
        "پس از اتمام مدت اعتبار بسته، می‌توانید بدون از دست دادن تاریخچۀ فعالیت‌های خود مجددا اعتبار بخرید.",
      package_item: {
        no_package: "بدون بسته",
        basic: "پایه",
        advanced: "پیشرفته",
        business: "تجاری",
        custom: "اختصاصی",
        basic_desc:
          "این بسته برای کسب‌و‌کارهای کوچک‌تر یا آن‌هایی که تازه شروع به تبلیغات کرده‌اند، مناسب‌ است.",
        advanced_desc:
          "این محبوب‌ترین بستۀ ماست و برای کسب‌وکارهای رو به رشد، بسیار مناسب است.",
        business_desc:
          "اگر کسب‌وکاری بزرگ را مدیریت می‌کنید، این بسته برای شماست.",
        custom_desc: "این بسته برای شما و متناسب با نیازتان ایجاد شده است.",
        campaign_feat: "قابلیت ساخت کمپین",
        sponroed_count: "{count} بازدید تبلیغ پُست کانال",
        // campaign: "کمپین",
        most_favorite: "محبوب‌ترین",
        concurrent_count: "قابلیت فعال‌سازی هم‌زمان {count} کمپین",
        overall_view: "{count} بازدید تب گفتگو",
        daily_view: "{count}  بازدید روزانه",
        no_onboarding: "عدم نمایش در صفحۀ آنبوردینگ «بله»",
        onboarding_period: "{days} روز نمایش در صفحۀ آنبوردینگ «بله»",
        // bale_onboarding: "",
        credit_expire: "{days} روز اعتبار مصرف",
        price_in_rials: "{price} ریال",
        campaign_title: "قابلیت کمپین",
        campaign_help:
          "کمپین، تبلیغی است که تاریخ انقضا ندارد و می‌توانید آن را به صورت دستی، فعال و غیرفعال کنید.",
        onboarding_title: "",
        onboarding_help: "",
      },
    },
  },
  tutorials: {
    title: "آموزش تبلیغات",
    check_tutorial: "مشاهدۀ آموزش تبلیغات",
    articles_list: "لیست مقالات",
    videos_list: "لیست ویدیوهای آموزشی",
    breadcrumb: {
      all: "همۀ محتواها",
      videos: "ویدیوهای آموزشی",
      articles: "مقالات",
    },
    sections: {
      categories: "آموزش بر اساس موضوع",
      most_visited_articles: "مقالات پربازدید",
      most_visited_videos: "ویدیوهای آموزشی پربازدید",
      show_all_articles: "مشاهدۀ همۀ مقالات",
      show_all_videos: "مشاهدۀ همۀ ویدیوها",
    },
    categories: {
      ad_Writing: "تبلیغ‌نویسی",
      ad_panel: "کار با پنل تبلیغات",
      packages: "بسته‌های تبلیغاتی",
      ad_spots: "جایگاه تبلیغاتی",
    },
    cards: {
      call_to_action: "برای {text} کلیک کنید",
      read_article: "مطالعۀ مقاله",
      watch_video: "مشاهدۀ ویدیو",
    },
  },
  priceFooter: {
    discount_badge: "با تخفیف حمایتی",
    text: "با انتخاب گزینه «{text}»، {percentage}٪ به مبلغ نهایی اضافه شد.",
  },
  festival: {
    fabTitle: "شرکت در جشنواره",
    fabWheelTitle: "گردونه رو بچرخون",
    helpModal: {
      title: "جشنواره عیدانه بله🌱🎉",
      notes: [
        "🔸 کد تخفیف ۲۵ درصدی برای ثبت تبلیغ در تب گفتگو؛ فقط برای ۱۰۰ نفر.😍",
        "🔸 ۴ میلیون خرید کن و وارد گردونهٔ شانس شو.🔮",
        "🎁 جوایز گردونه:",
        [
          "      تبلیغ رایگان",
          "      اعتبار تبلیغ",
          "      کد تخفیف ۲۰ درصدی تب گفتگو",
          "      و کلی جایزهٔ دیگه که تو جشنواره وجود داره، دست خالی از پیش ما نمی‌ری!🎊",
        ],
        "⏰ این جشنواره از ۴ فروردین تا ۱۸ فروردین ادامه داره😍",
        "ℹ️ برای استفاده از کد تخفیف باید حداقل یک تبلیغ تب گفتگو ۴ میلیون تومانی ثبت کنی.",
        "ℹ️ سقف کد تخفیف ۲ میلیون تومان هست.",
        "🎁 کد تخفیف: BALE_EYEDFETR100",
      ],
    },
    luckyWheel: {
      button: "بچرخون",
      prizeFixedText: "منتظر باش تو 48 ساعت آینده بهت پیام میدیم😍",
      back: "بازگشت به خانه",
    },
  },
  pricing: {
    title: "قیمت تبلیغات",
    baleLink: {
      title: "تعرفهٔ تبلیغات با لینک داخل بله",
      help: `تعرفه‌ به‌ازای هر یک بازدید/کلیک است.
حداقل سفارش تبلیغ بازدیدی ۴۰۰٬۰۰۰ بازدید، تبلیغ کلیکی ۷٬۰۰۰ کلیک و تبلیغ پست کانال ۱۰۰٬۰۰۰ بازدید است.`,
      table: {
        headers: {
          splitter: "نوع تبلیغ/تعداد اعضا کانال",
          horizontal: ["۲٬۰۰۰ عضو", "۲٬۰۰۰ تا ۵٬۰۰۰ عضو ", "بیش از ۵٬۰۰۰ عضو"],
          vertical: [
            "تبلیغ بازدیدی تب گفتگو",
            "تبلیغ کلیکی تب گفتگو",
            "تبلیغ پست کانال",
          ],
        },
        data: [
          [
            { text: "1٬۵ تومان", badge: "۵۰% تخفیف" },
            { text: "۱٬۹۵ تومان", badge: "۳۵% تخفیف" },
            { text: "۳ تومان" },
          ],
          [
            { text: "275 تومان", badge: "۵۰% تخفیف" },
            { text: "357 تومان", badge: "۳۵% تخفیف" },
            { text: "۵۵۰ تومان" },
          ],
          [{ text: "۱۴ تومان" }, { text: "۱۴ تومان" }, { text: "۱۴ تومان" }],
        ],
      },
    },
    externalLink: {
      title: "تعرفهٔ تبلیغات با لینک خارج بله",
      help: ` تعرفه‌ به‌ازای هر یک بازدید/کلیک است.
حداقل سفارش تبلیغ بازدیدی ۴۰۰٬۰۰۰ بازدید، تبلیغ کلیکی ۷٬۰۰۰ کلیک و تبلیغ پست کانال ۱۰۰٬۰۰۰ بازدید است.`,
      table: {
        headers: {
          splitter: "نوع تبلیغ ",
          horizontal: ["قیمت"],
          vertical: [
            "تبلیغ بازدیدی تب گفتگو",
            "تبلیغ کلیکی تب گفتگو",
            "تبلیغ پست کانال",
          ],
        },
        data: [
          [{ text: "6 تومان" }],
          [{ text: "۱٬۱۰۰ تومان" }],
          [{ text: "20 تومان" }],
        ],
      },
    },
  },
};
